export const ALL_REPORT_REQUEST = "ALL_REPORT_REQUEST";
export const ALL_REPORT_SUCCESS = "ALL_REPORT_SUCCESS";
export const ALL_REPORT_FAIL = "ALL_REPORT_FAIL";

export const CREATE_ADMIN_BLOCK_REPORT_REQUEST = "CREATE_ADMIN_BLOCK_REPORT_REQUEST";
export const CREATE_ADMIN_BLOCK_REPORT_SUCCESS = "CREATE_ADMIN_BLOCK_REPORT_SUCCESS";
export const CREATE_ADMIN_BLOCK_REPORT_FAIL = "CREATE_ADMIN_BLOCK_REPORT_FAIL";

export const ALL_BUYER_DIALOG_REQUEST = "ALL_BUYER_DIALOG_REQUEST";
export const ALL_BUYER_DIALOG_SUCCESS = "ALL_BUYER_DIALOG_SUCCESS";
export const ALL_BUYER_DIALOG_FAIL = "ALL_BUYER_DIALOG_FAIL";

export const CDR_DETAILS_REQUEST = "CDR_DETAILS_REQUEST";
export const CDR_DETAILS_SUCCESS = "CDR_DETAILS_SUCCESS";
export const CDR_DETAILS_FAIL = "CDR_DETAILS_FAIL";
export const CDR_DETAILS_RESET = "CDR_DETAILS_RESET";

// Post-call SIP log panel — lazy-loaded sub-slice under cdrDetails
export const CDR_SIP_LOG_REQUEST = "CDR_SIP_LOG_REQUEST";
export const CDR_SIP_LOG_SUCCESS = "CDR_SIP_LOG_SUCCESS";
export const CDR_SIP_LOG_FAIL = "CDR_SIP_LOG_FAIL";
export const CDR_SIP_LOG_RESET = "CDR_SIP_LOG_RESET";